import { Box } from '@mui/material';
import { SEVERITY } from './warningTheme';

// "3 of 20 flagged" as a severity-tinted chip instead of grey body text - the first thing a viewer wants from
// a results page is "is anything wrong?", so it reads at a glance.
const FlagSummary = ({ warningCount, totalEvaluated, unit = '', children }) => {
  const bad = warningCount > 0;
  const c = bad ? SEVERITY.warning : SEVERITY.clear;
  return (
    <Box display="flex" alignItems="center" gap={1.5} flexWrap="wrap" sx={{ mb: 2 }}>
      <Box sx={{ bgcolor: c.pillBg, color: c.pillText, borderRadius: '999px', px: 1.75, py: 0.5, fontSize: 13, fontWeight: 700 }}>
        {bad ? `${warningCount} of ${totalEvaluated}${unit} flagged` : `All ${totalEvaluated}${unit} clear`}
      </Box>
      {children && <Box sx={{ fontSize: 13, color: '#6B6B66' }}>{children}</Box>}
    </Box>
  );
};

export default FlagSummary;
